/** @jsx jsx **/
import { jsx, Flex, Text, Box } from 'theme-ui'
import FilterSelectedItems from '~/components/filter/filter-selected-items'
import { useFilterContext } from '~/context/filters'
import { TSort, TSortAction } from '~/hooks/use-paginated-collection'
import Select, { SingleValue, components } from 'react-select'
import { SortBySelect } from './styles'

type Props = {
  itemsCount?: number
  setSort?: TSortAction
  collectionHandle: string
  sort: TSort
  hasFilters?: boolean
  hiddenSort?: Array<string> | null
}

const hiddenSortPages = ['antique-rugs']

export const FilterBadge = ({
  itemsCount,
  setSort,
  sort,
  collectionHandle,
  hasFilters,
  hiddenSort,
}: Props) => {
  const { selectedValuesArray, toggleValue } = useFilterContext()

  const handleSortChange = (e: { value: string; label: string }) => {
    if (!setSort) return
    setSort(e.value as any)
  }

  const sortOptions = {
    Price: [
      {
        value: 'price_asc',
        label: 'Price: Low - High',
      },
      {
        value: 'price_desc',
        label: 'Price High - Low',
      },
    ],
  }

  const activeSortOptions = Object.entries(sortOptions)
    .filter(([key]) => !hiddenSort?.includes(key))
    .flatMap(([, values]) => values)

  const options: Array<{ value: string; label: string }> = [
    {
      value: 'recommended',
      label: 'Recommended',
    },
    ...activeSortOptions,
  ]

  const VALUE_PREFIX = 'Sort by: '

  return (
    <Flex
      sx={{
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: '12px',
        width: '100%',
        alignItems: 'start',
        justifyContent: 'space-between',
        mt: hasFilters ? [60, null, 0] : 0,
      }}
    >
      {selectedValuesArray && selectedValuesArray.length > 0 && (
        <Flex sx={{ flexWrap: 'wrap', gap: '12px', flex: 1 }}>
          <FilterSelectedItems selectedFilters={selectedValuesArray} handleChange={toggleValue} />
        </Flex>
      )}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-end',
          gap: '12px',
          flex: 1,
        }}
      >
        {itemsCount ? (
          <Text
            sx={{
              display: hasFilters ? ['none', null, null, 'block'] : 'block',
              minWidth: '100px',
              color: '#808080',
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '24px',
              letterSpacing: '0.5px',
              padding: '9px 0',
              textAlign: 'right',
            }}
          >
            {itemsCount} {itemsCount > 1 ? 'items' : 'item'}
          </Text>
        ) : null}

        {!hiddenSortPages.includes(collectionHandle) && options?.length > 1 ? (
          <SortBySelect>
            <Select
              // menuIsOpen={true}
              className="sortby-select-container"
              options={options as any} // FIXME: TypeScript complains about
              defaultValue={sort || options[0]}
              onChange={handleSortChange as any} // FIXME: TypeScript complains about
              aria-label="Sort"
              components={{
                SingleValue: ({ children, ...props }) => {
                  return (
                    <components.SingleValue {...props}>
                      {VALUE_PREFIX} <strong>{children}</strong>
                    </components.SingleValue>
                  )
                },
                Placeholder: ({ children, ...props }) => {
                  return (
                    <components.Placeholder {...props}>
                      {VALUE_PREFIX} <strong>{children}</strong>
                    </components.Placeholder>
                  )
                },
                IndicatorSeparator: () => null,
              }}
              classNames={{
                control: (state: any) => {
                  return `sortBy-select-control ${state.isFocused ? 'focused' : 'not-focused'}`
                },
                menu: (state: any) => {
                  return `sortBy-select-menu ${state.selectProps.menuIsOpen ? 'open' : 'closed'}`
                },
                option: (state: any) => {
                  return `sortBy-select-option ${state.isFocused ? 'focused' : 'not-focused'} ${
                    state.isSelected ? 'selected' : ''
                  }`
                },
              }}
            />
          </SortBySelect>
        ) : null}
      </Box>
    </Flex>
  )
}
